import { useContext } from 'react';
import TranslationContext from './TranslationContext';
export default function useT() {
    return useContext(TranslationContext).t;
}
